module.exports = __webpack_public_path__ + "img/activation_rocket.a0b00b5a.svg";